import { useQuery } from "@apollo/client";
import { OrgDocument } from "./__generated__/Org.generated";

export const useOrgId = () => {
  const { data, loading, error } = useQuery(OrgDocument);
  const orgId = data?.viewer.user?.orgs.edges?.[0]?.node?.id ?? null;

  return { orgId, loading, error };
};
